import { z } from 'zod';
import { priorityIdSchema } from '../priority/index.js';
import { requiredUuidString } from '../zod-helpers/index.js';
import { MANUFACTURING_ORDER_CONSTRAINTS } from './constraints.js';
import { workOrderNoteSchema } from './work-order-note.js';
/** The facts about a work order that belong to the floor rather than to the recipe. */
export const workOrderDetailsInputSchema = z.object({
    // undefined = leave unchanged; null or blank = clear the note
    note: workOrderNoteSchema.optional(),
    priorityId: priorityIdSchema.optional(),
    /**
     * Who is running it. Absent leaves the crew alone — re-prioritising must not unassign everyone —
     * and an empty list is the explicit "take them all off".
     */
    assignedUserIds: z
        // A blank id is refused rather than dropped, which would turn "assign this person" into the
        // empty list the resolver reads as "take everyone off".
        .array(requiredUuidString('An assignee is required.', 'Invalid assignee selection.'))
        .max(MANUFACTURING_ORDER_CONSTRAINTS.assignees.max, `A work order takes at most ${MANUFACTURING_ORDER_CONSTRAINTS.assignees.max} assignees.`)
        .optional()
        .transform((value) => (value === undefined ? undefined : [...new Set(value)])),
});
//# sourceMappingURL=work-order-details-input.js.map